(function () {
(($)=>{
    $(document).ready(function() {
        const $faq = $(".wp-block-yoast-faq-block");
        if (!$faq.length) return;
        function toggleSection($question) {
            const $section = $question.closest(".schema-faq-section");
            const open = !$section.hasClass("is-open");
            $section.toggleClass("is-open", open);
            $question.attr("aria-expanded", open ? "true" : "false");
        }
        $faq.each(function() {
            const $wrapper = $(this);
            $wrapper.addClass("is-accordion");
            // Nettoyage du markup généré par Yoast :
            // - <p></p> vides (ou ne contenant que du blanc)
            $wrapper.find("p").each(function() {
                const $p = $(this);
                if ($p.text().trim() === "" && !$p.find("img, iframe, svg, br").length) $p.remove();
            });
            // - <strong> imbriqués dans les questions (ex. <strong><strong>…</strong></strong>)
            $wrapper.find(".schema-faq-question").each(function() {
                const $question = $(this);
                $question.find("strong").contents().unwrap();
                // Accessibilité : la question devient un bouton clavier/lecteur d'écran
                $question.attr({
                    role: "button",
                    tabindex: 0,
                    "aria-expanded": "false"
                }).on("click", function() {
                    toggleSection($question);
                }).on("keydown", function(e) {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        toggleSection($question);
                    }
                });
            });
            // Deuxième item ouvert par défaut
            const $secondQuestion = $wrapper.find(".schema-faq-question").eq(1);
            if ($secondQuestion.length) toggleSection($secondQuestion);
        });
    });
})(jQuery);

})();
//# sourceMappingURL=faq-yoast.js.map
